module.exports = __webpack_public_path__ + "img/87.04e7a517.jpg";